export default {
  routes: [
    {
      name: 'taxonomies',
      path: '/admin/taxonomy2',
      component: () => import('./views/TheTaxonomies.vue'),
    },

    {
      name: 'taxonomy',
      path: '/admin/taxonomy2/:uuid',
      component: () => import('./views/TheTaxonomy.vue'),
    },

    {
      path: '/',
      redirect: '/admin/taxonomy2',
    }
  ]
}
